<template>
  <div>
    <vxe-grid
      ref="docTable"
      :data.sync="v_tableData"
      :columns="tableColumns"
      :height="333"
      auto-resize
      highlight-hover-row
      border
      size="mini"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
    >
      <template v-slot:top>
        <div class="side-frame">
          <span class="side-frame-text">
            {{ $l('group_title_doc') || '费用相关文档' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="UploadDocDialogVisible = true"
            v-if="!disabled"
            ><i class="el-icon-plus" /> {{ $l('INDEX.btn_upload') || '上传' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            v-if="!disabled"
            @click="batchDelDoc()"
            ><i class="el-icon-delete" />{{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:docType="{ row }">
        <el-tag
          v-if="row.v_docType"
          size="mini"
          :type="row.docType === 'S' ? '' : 'warning'"
        >
          {{ row.v_docType }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_downloada') || '下载'"
            placement="top"
          >
            <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled && row.docType === 'S'"
          >
            <i class="el-icon-delete tool-btn" @click="delDoc(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="'查看'"
            placement="top"
            v-if="row.docType === 'P'"
          >
            <i class="el-icon-picture tool-btn" @click="previewImage(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <UploadDocDialog
      ref="uploadDoc"
      :title="$l('dialog_title_upload_doc') || '上传费用相关文档'"
      :visible.sync="UploadDocDialogVisible"
      @upload="onDocUpload"
    />

    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img :src="previewImageUrl" />
    </div>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import UploadDocDialog from '../upload-doc'
export default {
  components: { UploadDocDialog },
  props: {
    disabled: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      v_tableData: [],
      tableColumns: tableColumns(this),
      UploadDocDialogVisible: false,
      previewImageUrl: '',
    }
  },
  watch: {
    tableData: {
      handler(e) {
        this.v_tableData = e || []
      },
      immediate: true,
    },
  },
  methods: {
    getTableData() {
      const { fullData } = this.$refs.docTable.getTableData()
      return fullData
    },
    onDocUpload(e) {
      const { remark = '', listDoc } = e
      const data = listDoc.reduce((result, next) => {
        result.push({ ...next, remark })
        return result
      }, [])
      this.addDoc(data)
    },
    batchDelDoc() {
      this.$refs.docTable.removeCheckboxRow()
    },
    delDoc(row) {
      this.$refs.docTable.remove(row)
    },
    downloadFile({ fileCode = '' }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
    addDoc(data) {
      data.forEach((item) => {
        item.docType = 'S'
      })
      const tableData = this.getTableData()
      tableData.unshift(...data)
      this.v_tableData = [...tableData]
    },
    previewImage({ fileUrl, docType }) {
      if (docType !== 'P') return
      this.previewImageUrl = fileUrl
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      viewer.show()
    },
  },
}
</script>
